/**
 * @module toggleButton
 */

module.exports = function( button ) {
    const labels = {
        en: { showMore: 'Show more', showLess: 'Show less' },
        de: { showMore: 'Mehr anzeigen', showLess: 'Weniger anzeigen' },
        fr: { showMore: 'Afficher plus', showLess: 'Afficher moins' },
        es: { showMore: 'Mostrar más', showLess: 'Mostrar menos' },
        pt: { showMore: 'Mostrar mais', showLess: 'Mostrar menos' },
    };

    const currentLanguage = document.querySelector( 'html' ).getAttribute( 'lang' ).slice( 0, 2 );

    button.addEventListener( 'click', () => {
        const { showMore, showLess } = labels[ currentLanguage ];

        if ( button.textContent.trim() === showMore ) {
            button.textContent = showLess;
        } else {
            button.textContent = showMore;
        }
    } );
};// exports
